import {i18n, type Locale} from '../../i18n.config';

export function localizePath(unlocalizedPath: string, locale: Locale): string {
  if (locale === i18n.defaultLocale) {
    return unlocalizedPath;
  }
  return `/${locale}${unlocalizedPath}`;
}

export const languages = {
  en: {name: 'English', nativeName: 'English', flag: '🇺🇸'},
  ca: {name: 'Catalan', nativeName: 'Català', flag: '🇦🇩'},
  zh: {name: 'Chinese', nativeName: '中文', flag: '🇨🇳'},
  cs: {name: 'Czech', nativeName: 'čeština', flag: '🇨🇿'},
  nl: {name: 'Dutch', nativeName: 'Nederlands', flag: '🇳🇱'},
  fr: {name: 'French', nativeName: 'Français', flag: '🇫🇷'},
  de: {name: 'German', nativeName: 'Deutsch', flag: '🇩🇪'},
  it: {name: 'Italian', nativeName: 'Italiano', flag: '🇮🇹'},
  ja: {name: 'Japanese', nativeName: '日本語', flag: '🇯🇵'},
  ko: {name: 'Korean', nativeName: '한국어', flag: '🇰🇷'},
  pt: {name: 'Portuguese', nativeName: 'Português', flag: '🇵🇹'},
  ru: {name: 'Russian', nativeName: 'Русский', flag: '🇷🇺'},
  es: {name: 'Spanish', nativeName: 'Español', flag: '🇪🇸'},
};
